import { Col, Row } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import { openModalConfirmacao } from 'components/Modal/ModalConfirmacao';
import { fetchNotificationApp, fetchStatusModal } from 'store/fetchActions/fetchApp';
import { convertBase64, downloadFileBase64, converterByteToMb } from 'utils/arquivo';
import { ALERTA, STATUS_REQUERIMENTO, ENUM_CARGO, ENUM_MODAL } from 'utils/consts';
import { fetchDownloadArquivo } from 'store/fetchActions/fetchArquivo';
import { validationNomeTamanhoArquivo } from 'utils/validate/arquivo';
import { generateId } from 'utils/funcaoPadrao';
import { requerimentos } from 'routes/paths';
import * as S from './styles';

export const getRotaFinalizar = status => {
  if (status === STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE.identificador) return requerimentos;
  if (status === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador) return requerimentos;
  if (status === STATUS_REQUERIMENTO.FINALIZADO_DEFERIDO.identificador) return requerimentos;
  if (status === STATUS_REQUERIMENTO.FINALIZADO_INDEFERIDO.identificador) return requerimentos;
  if (status === STATUS_REQUERIMENTO.FINALIZADO_PROCESSO_GERADO.identificador) return requerimentos;
  if (status === STATUS_REQUERIMENTO.SOLICITACAO_ATENDIDA.identificador) return requerimentos;
  if (status === STATUS_REQUERIMENTO.CANCELADO.identificador) return requerimentos;

  return null;
};

export const abrirArquivoBanco = async arquivo => {
  fetchDownloadArquivo(arquivo?.id);
  fetchNotificationApp(
    'Baixando arquivo...',
    'Aguarde finalizar o download para continuar',
    ALERTA.INFO,
    'bottomRight'
  );
};

export const abrirArquivo = async arquivo => {
  if (!arquivo?.grupoId || !arquivo.arquivoExternoId) {
    convertBase64(arquivo).then(fileBase => {
      downloadFileBase64(fileBase);
    });
  } else {
    abrirArquivoBanco(arquivo);
  }
};

export const adicionarNovoArquivo = (file, tamanhoTotalArquivos) => {
  const tamanhoTotalMb = parseFloat(converterByteToMb(file?.size)) + (parseFloat(tamanhoTotalArquivos) || 0);
  if (validationNomeTamanhoArquivo(file, tamanhoTotalMb)) {
    const arquivoNovo = file;
    arquivoNovo.id = generateId();
    arquivoNovo.data = new Date();

    return { tamanhoTotal: tamanhoTotalMb?.toFixed(2), novoArquivo: arquivoNovo, isValid: true };
  }
  return { tamanhoTotal: 0, novoArquivo: null, isValid: false };
};

export const removerArquivo = (id, arquivos, tamanhoTotalArquivos = 0) => {
  const novosAquivos = [];
  let tamanhoTotalMb = tamanhoTotalArquivos;

  for (let anexo of arquivos) {
    if (anexo?.id !== id) novosAquivos.push(anexo);
    if (anexo?.id === id) {
      tamanhoTotalMb = parseFloat(tamanhoTotalMb) - parseFloat(converterByteToMb(anexo?.size));
    }
  }

  return { tamanhoTotal: tamanhoTotalMb?.toFixed(2), novosAquivos: novosAquivos };
};

export const renderArquivos = (arquivos, handleAbrirArquivo, handleRemoverArquivo) => {
  if (arquivos?.length === 0)
    return (
      <Col style={{ margin: '20px 0px' }}>
        <PaperClipOutlined /> Nenhum anexo encontrado para esse requerimento
      </Col>
    );
  return (
    <Col style={{ margin: '20px 0px' }}>
      <PaperClipOutlined /> Anexos:
      {arquivos?.map(item => {
        return (
          <Row key={item?.id || item?.key}>
            <S.NomeArquivo onClick={() => handleAbrirArquivo(item)}>{item?.nomeArquivo || item?.name}</S.NomeArquivo>
            {item?.data && <S.ApagarArquivo onClick={() => handleRemoverArquivo(item?.id)}>Apagar</S.ApagarArquivo>}
          </Row>
        );
      })}
    </Col>
  );
};

export const disableActionPerfil = (cargoAtendenteLogado, statusIndeferidor) => {
  if (cargoAtendenteLogado === ENUM_CARGO.SUPERVISOR) {
    return statusIndeferidor === STATUS_REQUERIMENTO.ABERTO.identificador;
  } else {
    return (
      statusIndeferidor === STATUS_REQUERIMENTO.ABERTO.identificador ||
      statusIndeferidor === STATUS_REQUERIMENTO.EM_ANALISE.identificador ||
      statusIndeferidor === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador
    );
  }
};

export const exibirModalResumoFinalizar = (
  status,
  funcFinalizar,
  titleModalAnterior,
  justificativa,
  arquivos
) => dispatch => {
  dispatch(
    fetchStatusModal(true, ENUM_MODAL.RESUMO_REQUERIMENTO, {
      funcFinalizar: funcFinalizar,
      status: status,
      modalAnterior: titleModalAnterior,
      justificativa: justificativa,
      arquivos: arquivos,
    })
  );
};

export const verificarAvisoFormulario = (statusRequerimento, isEqualsAtendente, functionExecute, status) => {
  if (
    statusRequerimento === STATUS_REQUERIMENTO.ABERTO.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.DIRECIONADO_OUTRO_ATENDENTE.identificador
  ) {
    functionExecute(status);
  }
  if (!isEqualsAtendente) {
    openModalConfirmacao({
      title: 'Protocolo em atendimento por outro usuário. Deseja realizar essa ação?',
      descricao: '',
      funcSuccess: () => functionExecute(status),
    });
  } else {
    functionExecute(status);
  }
};

export const fraseUsuarioSefaz =
  'Preencha o campo justificativa para que o contribuinte tenha acesso, e se necessário adicione anexos referente a solicitação. Os arquivos devem ser no formato PDF.';

export const fraseContribuinte =
  'Preencha o campo justificativa, e se necessário adicione anexos referente a solicitação. Os arquivos devem ser no formato PDF.';

export const renderFrase = titleModal => {
  if (titleModal === ENUM_MODAL.JUSTIFICATIVA.USUARIO_FRENTE) return fraseUsuarioSefaz;
  if (titleModal === ENUM_MODAL.JUSTIFICATIVA.USUARIO_SETORIAL) return fraseUsuarioSefaz;
  if (titleModal === ENUM_MODAL.JUSTIFICATIVA.CONTRIBUINTE) return fraseContribuinte;
  return '';
};
